export type CountRouteSearch = {
  /** Every row in a count shares one warehouse, so it is page-level rather than per-row. */
  locationGroupId?: string;
  /** Set for a bin count. */
  locationId?: string;
  /** Set for a part count, chasing one SKU across the warehouse's bins. */
  partId?: string;
  /** Unset counts every brand the counter belongs to; set narrows the count to that one brand. */
  brandId?: string;
  /** Opens setup filled in with the other keys instead of starting the count, for shortcuts. */
  prefill?: boolean;
};

function text(value: unknown): string | undefined {
  return typeof value === 'string' && value !== '' ? value : undefined;
}

export function parseCountRouteSearch(search: Record<string, unknown>): CountRouteSearch {
  return {
    locationGroupId: text(search.locationGroupId),
    locationId: text(search.locationId),
    partId: text(search.partId),
    brandId: text(search.brandId),
    prefill: search.prefill === true || search.prefill === 'true' ? true : undefined,
  };
}
